import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
.p-step:has(~ .p-step-active) .p-step-number {
	border-color: ${dt('primary.300')};
	color: ${dt('primary.300')};
}

.p-step:has(~ .p-step-active) .p-step-title {
	color: ${dt('primary.300')};
}
`;
